var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.planAllow("edit-cv-pro")
        ? _c(
            "vs-button",
            {
              class: [
                "ml-2",
                "vs-con-loading__container",
                { exportPDF: "vs-con-loading__container" },
              ],
              attrs: {
                id: "export-pdf-button",
                color: "primary",
                type: "filled",
                "icon-pack": "feather",
                icon: "icon-file-text",
              },
              on: {
                click: function ($event) {
                  _vm.showPrompt = true
                },
              },
            },
            [_vm._v("\n        CV\n    ")]
          )
        : !_vm.shouldHideOptions()
        ? _c(
            "div",
            {
              staticStyle: { position: "relative", float: "left" },
              attrs: {
                title: "Votre formule n'inclut pas cette fonctionnalité",
              },
            },
            [
              _c(
                "vs-button",
                {
                  staticClass: "ml-2 includeIcon",
                  attrs: {
                    id: "export-pdf-button",
                    color: "primary",
                    type: "filled",
                    "icon-pack": "feather",
                    icon: "icon-file-text",
                    disabled: "true",
                  },
                },
                [_vm._v("\n            CV\n        ")]
              ),
              _vm._v(" "),
              _c(
                "vs-icon",
                {
                  staticClass: "button-bullet",
                  attrs: { bg: "#FF9B3A", round: "" },
                },
                [
                  _c("CrownIcon", {
                    staticStyle: {
                      width: "16px",
                      height: "16px",
                      padding: "3px",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "DialogPrompt",
        {
          attrs: {
            active: _vm.showPrompt,
            title: "Paramètre de l'export",
            "cancel-text": "Annuler",
            "accept-text": "Lancer l'export",
          },
          on: {
            "update:active": function ($event) {
              _vm.showPrompt = $event
            },
            cancel: function ($event) {
              _vm.showPrompt = false
            },
            close: function ($event) {
              _vm.showPrompt = false
            },
            accept: _vm.initExport,
          },
        },
        [
          _c("div", [
            _c("p", [
              _vm._v(
                "\n                Choisissez les options d'export du CV de l'employé : \n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-2" }, [
            _c(
              "div",
              { staticClass: "py-2" },
              [
                _c(
                  "vs-checkbox",
                  {
                    model: {
                      value: _vm.withSkills,
                      callback: function ($$v) {
                        _vm.withSkills = $$v
                      },
                      expression: "withSkills",
                    },
                  },
                  [_vm._v("Exporter les compétences")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "py-2" },
              [
                _c(
                  "vs-checkbox",
                  {
                    model: {
                      value: _vm.withOccupationSkills,
                      callback: function ($$v) {
                        _vm.withOccupationSkills = $$v
                      },
                      expression: "withOccupationSkills",
                    },
                  },
                  [_vm._v("Exporter les savoir-faire")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "hide-pdf", attrs: { id: "cv-container" } }, [
        _c(
          "div",
          { ref: "cv" },
          [
            _vm.employee
              ? _c("CV", {
                  key: 0,
                  attrs: {
                    employee: _vm.employee,
                    withSkills: _vm.withSkills,
                    withOccupationSkills: _vm.withOccupationSkills,
                  },
                  on: {
                    loaded: function ($event) {
                      return _vm.download()
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }